export default __webpack_public_path__ + "static/media/640_business03-nl-web.06c0228f.png";